export default "__VITE_ASSET__8ea19e83__"